export default __webpack_public_path__ + "static/soups_head-2acb14c18d57d753eef7e368f66dcaa3.png";